import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetUserLevels } from "src/app/store/user-level/user-level.action";

export function UserLevelsResolver() {
    return inject(Store).dispatch(new GetUserLevels());
}